"use client";

import HomeMentorsSection from "@/components/global/sections/home/MentorsSection";
import type { GROQButton } from "@/sanity/lib/definitions";
import { CTAButton } from "@/shadcn/ui/button";
import type { PortableTextBlock } from "sanity";

import { CommunityChip, CommunityPortableText, TITLE_TRIM } from "./_shared";
import type { ICommunityMentor } from "./types";

interface MentorsSectionProps {
  desktopChip?: string;
  desktopTitle?: PortableTextBlock[];
  desktopDescription?: PortableTextBlock[];
  mobileChip?: string;
  mobileTitle?: PortableTextBlock[];
  mentors?: ICommunityMentor[];
  cta?: GROQButton;
}

export default function MentorsSection({
  desktopChip,
  desktopTitle,
  desktopDescription,
  mobileChip,
  mobileTitle,
  mentors,
  cta,
}: MentorsSectionProps) {
  const items = mentors ?? [];

  return (
    <HomeMentorsSection
      variant="community"
      mentors={items}
      mobileHeader={
        <div className="flex w-full flex-col items-center gap-[3rem] px-[2rem] text-center lg:hidden">
          {mobileChip && <CommunityChip>{mobileChip}</CommunityChip>}
          <CommunityPortableText
            value={mobileTitle}
            className={`richtext-center w-[min(35.5rem,100%)] [text-wrap:balance] ${TITLE_TRIM} prose-p:m-0 prose-p:font-news prose-p:text-[4.5rem] prose-p:leading-[1.1] prose-p:tracking-[-0.25rem] prose-p:text-white/90 prose-headings:m-0 prose-headings:font-news prose-headings:text-[4.5rem] prose-headings:leading-[1.1] prose-headings:font-normal prose-headings:tracking-[-0.25rem] prose-headings:text-white/90 prose-em:font-news prose-em:italic`}
          />
        </div>
      }
      desktopHeader={
        <div className="hidden w-full flex-col items-center gap-[2.5rem] text-center lg:flex">
          <div className="flex w-full flex-col items-center gap-[2rem]">
            {desktopChip && <CommunityChip className="w-full">{desktopChip}</CommunityChip>}
            <CommunityPortableText
              value={desktopTitle}
              className={`richtext-center w-[min(72.25rem,100%)] whitespace-pre-line ${TITLE_TRIM} prose-p:m-0 prose-p:font-news prose-p:text-[6rem] prose-p:leading-[1.1] prose-p:tracking-[-0.25rem] prose-p:text-white/90 prose-headings:m-0 prose-headings:font-news prose-headings:text-[6rem] prose-headings:leading-[1.1] prose-headings:font-normal prose-headings:tracking-[-0.25rem] prose-headings:text-white/90`}
            />
          </div>
          <CommunityPortableText
            value={desktopDescription}
            className="richtext-center w-[min(68.75rem,100%)] prose-p:m-0 prose-p:font-geist prose-p:text-[2.25rem] prose-p:leading-[1.5] prose-p:text-white/60"
          />
        </div>
      }
      mobileFooter={
        cta ? (
          <CTAButton
            data={cta}
            iconOverride="arrowRight"
            fullWidth
            className="w-full lg:hidden"
          />
        ) : null
      }
    />
  );
}
